import React from 'react';
import WithConsumer from '../context/WithConsumer';
import ThePost from './ThePost';
import Loader from '../partials/Loader'
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';

const TheLoop = ({ context }) => {

    const posts = () => context.posts;
    const pos = posts();

    // console.log(pos);

    let results = '';

    if(context.appError){
      results = <div className="app-error">{context.appError}</div>;
    }
    else if (pos) {
        if(pos.length === 0){
          results = <div className="no-results">
          <Loader />
          {/* <p><Link to="/" className="button header__back-button">
          Go Back
          </Link>
          </p> */}
          </div>;
        }else{
          results = pos.map(function(item,i){
              return <ThePost key={i} index={i}></ThePost>
            })
        }
    } else {
      results = <Loader />;
    }

    return (results);

};
export default WithConsumer(TheLoop);